import { Api, Config } from './api'

export const ApiObterUserInfoNc = async () => {
   const userInfo = JSON.parse(localStorage.getItem('userInfo'))
   
   if (userInfo == null || userInfo == undefined) {
      const { data } = await Api.get(`/usuarios/info`, Config())
      return data
   }

   return userInfo
}
